/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new user.
         * @param {CreateUserDto} createUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerCreate: (createUserDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createUserDto' is not null or undefined
            assertParamExists('usersV2ControllerCreate', 'createUserDto', createUserDto);
            const localVarPath = `/v2/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a new user entry for currentUser.
         * @param {CreateProfileDto} createProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerCreateMe: (createProfileDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createProfileDto' is not null or undefined
            assertParamExists('usersV2ControllerCreateMe', 'createProfileDto', createProfileDto);
            const localVarPath = `/v2/user/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createProfileDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find all Users.
         * @param {string} [externalAuthId]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerFindAllV3: (externalAuthId, workspaceId, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v3/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (externalAuthId !== undefined) {
                localVarQueryParameter['externalAuthId'] = externalAuthId;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerFindMe: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/user/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find user by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersV2ControllerFindOne', 'id', id);
            const localVarPath = `/v2/user/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete user by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerRemove: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersV2ControllerRemove', 'id', id);
            const localVarPath = `/v2/user/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a user.
         * @param {string} id
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerUpdate: (id, updateUserDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersV2ControllerUpdate', 'id', id);
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('usersV2ControllerUpdate', 'updateUserDto', updateUserDto);
            const localVarPath = `/v2/user/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new user.
         * @param {CreateUserDto} createUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerCreate(createUserDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersV2ControllerCreate(createUserDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a new user entry for currentUser.
         * @param {CreateProfileDto} createProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerCreateMe(createProfileDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersV2ControllerCreateMe(createProfileDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find all Users.
         * @param {string} [externalAuthId]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerFindAllV3(externalAuthId, workspaceId, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersV2ControllerFindAllV3(externalAuthId, workspaceId, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerFindMe(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersV2ControllerFindMe(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find user by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersV2ControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete user by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerRemove(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersV2ControllerRemove(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a user.
         * @param {string} id
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerUpdate(id, updateUserDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersV2ControllerUpdate(id, updateUserDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new user.
         * @param {CreateUserDto} createUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerCreate(createUserDto, options) {
            return localVarFp
                .usersV2ControllerCreate(createUserDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new user entry for currentUser.
         * @param {CreateProfileDto} createProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerCreateMe(createProfileDto, options) {
            return localVarFp
                .usersV2ControllerCreateMe(createProfileDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find all Users.
         * @param {string} [externalAuthId]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerFindAllV3(externalAuthId, workspaceId, page, pageSize, sortBy, options) {
            return localVarFp
                .usersV2ControllerFindAllV3(externalAuthId, workspaceId, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerFindMe(options) {
            return localVarFp
                .usersV2ControllerFindMe(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find user by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerFindOne(id, options) {
            return localVarFp
                .usersV2ControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete user by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerRemove(id, options) {
            return localVarFp
                .usersV2ControllerRemove(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a user.
         * @param {string} id
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersV2ControllerUpdate(id, updateUserDto, options) {
            return localVarFp
                .usersV2ControllerUpdate(id, updateUserDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     *
     * @summary Create a new user.
     * @param {CreateUserDto} createUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersV2ControllerCreate(createUserDto, options) {
        return UsersApiFp(this.configuration)
            .usersV2ControllerCreate(createUserDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new user entry for currentUser.
     * @param {CreateProfileDto} createProfileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersV2ControllerCreateMe(createProfileDto, options) {
        return UsersApiFp(this.configuration)
            .usersV2ControllerCreateMe(createProfileDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find all Users.
     * @param {string} [externalAuthId]
     * @param {string} [workspaceId]
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersV2ControllerFindAllV3(externalAuthId, workspaceId, page, pageSize, sortBy, options) {
        return UsersApiFp(this.configuration)
            .usersV2ControllerFindAllV3(externalAuthId, workspaceId, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersV2ControllerFindMe(options) {
        return UsersApiFp(this.configuration)
            .usersV2ControllerFindMe(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find user by id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersV2ControllerFindOne(id, options) {
        return UsersApiFp(this.configuration)
            .usersV2ControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete user by id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersV2ControllerRemove(id, options) {
        return UsersApiFp(this.configuration)
            .usersV2ControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a user.
     * @param {string} id
     * @param {UpdateUserDto} updateUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersV2ControllerUpdate(id, updateUserDto, options) {
        return UsersApiFp(this.configuration)
            .usersV2ControllerUpdate(id, updateUserDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
